export const typeOptions = [
  { value: 'I', label: 'اطلاعاتی (I)' },
  { value: 'N', label: 'مسیر (N)' },
  { value: 'T', label: 'تراکنشی (T)' },
  { value: 'C', label: 'تجاری (C)' },
  { value: 'long-tail', label: 'طولانی' },
  { value: 'trending', label: 'ترندی' },
  { value: 'high-search', label: 'جستجوی بالا' },
  { value: 'lsi', label: 'LSI' },
  { value: 'content-idea', label: 'ایده محتوا' },
  { value: 'local', label: 'محلی' },
  { value: 'low-competition', label: 'کم رقابت' },
  { value: 'fomo', label: 'FOMO' },
  { value: 'question', label: 'سوالی' },
  { value: 'suggested', label: 'پیشنهادی' }
];

export const goalOptions = [
  { label: 'مقاله آموزشی', value: 'مقاله آموزشی' },
  { label: 'صفحه خدمات', value: 'صفحه خدمات' },
  { label: 'صفحه محصول', value: 'صفحه محصول' },
  { label: 'صفحه اصلی', value: 'صفحه اصلی' },
  { label: 'لندینگ تبلیغاتی', value: 'لندینگ تبلیغاتی' },
  { label: 'دسته‌بندی یا بلاگ', value: 'دسته‌بندی یا بلاگ' }
];
